import { api } from "@/lib/api";
import type { ApiResponse, TrainingOffering } from "@learn-me/types";

export interface OfferingInput {
  category: "PROGRAMA" | "CAPACITACION";
  title: string;
  summary: string;
  focusAreas: string[];
  durationLabel: string;
  modalities: string[];
  coverImageUrl?: string | null;
  isPublished: boolean;
  position?: number;
}

export interface OfferingRequestInput {
  companyName: string;
  contactName: string;
  email: string;
  phone?: string;
  message: string;
  /** Programa desde el que se solicita, cuando aplica */
  offeringId?: string;
}

export const offeringsApi = {
  async listPublic(category?: string): Promise<TrainingOffering[]> {
    const qs = category ? `?category=${encodeURIComponent(category)}` : "";
    const response = await api.get<ApiResponse<TrainingOffering[]>>(
      `/offerings${qs}`,
    );
    return response.data.data!;
  },

  async getBySlug(slug: string): Promise<TrainingOffering> {
    const response = await api.get<ApiResponse<TrainingOffering>>(
      `/offerings/${slug}`,
    );
    return response.data.data!;
  },

  async submitRequest(data: OfferingRequestInput): Promise<void> {
    await api.post("/enterprise/contact", data);
  },

  // ---- Administración ----

  async listAll(): Promise<TrainingOffering[]> {
    const response = await api.get<ApiResponse<TrainingOffering[]>>(
      "/offerings/admin/all",
    );
    return response.data.data!;
  },

  async getById(id: string): Promise<TrainingOffering> {
    const response = await api.get<ApiResponse<TrainingOffering>>(
      `/offerings/admin/${id}`,
    );
    return response.data.data!;
  },

  async create(data: OfferingInput): Promise<TrainingOffering> {
    const response = await api.post<ApiResponse<TrainingOffering>>(
      "/offerings",
      data,
    );
    return response.data.data!;
  },

  async update(
    id: string,
    data: Partial<OfferingInput>,
  ): Promise<TrainingOffering> {
    const response = await api.put<ApiResponse<TrainingOffering>>(
      `/offerings/${id}`,
      data,
    );
    return response.data.data!;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/offerings/${id}`);
  },

  async reorder(
    offerings: Array<{ id: string; position: number }>,
  ): Promise<void> {
    await api.put("/offerings/reorder", { offerings });
  },
};
